import { useParams } from 'react-router';
import AppointmentsView from './shared/AppointmentsView';
import { Api } from '../../api';
import { ScreenError, SoloLoading } from '../../components';
import { useApiRead } from 'api-read-hook';

export default function ClinicianAppointments() {
  const { id } = useParams();

  const clinicianApi = useApiRead<Api.User.V_ClinicianDetailAsAdmin>(
    id ? `/clinicians/${id}` : null,
  );

  if (!id) return null;

  if (clinicianApi.error) return <ScreenError {...clinicianApi} />;
  if (!clinicianApi.data) return <SoloLoading />;

  const clinicianProfile = clinicianApi.data.clinicianProfile;
  if (!clinicianProfile)
    return <ScreenError error={new Error('Clinician has no profile.')} />;

  return (
    <AppointmentsView
      clinicianId={id}
      timezone={clinicianApi.data.timezone}
      bufferMinutes={clinicianProfile.appointmentBuffer}
      breadcrumbs={[{ name: 'Clinicians', url: '/clinicians' }]}
      editButtonText="Edit their schedule"
    />
  );
}
